/* eslint-disable react/no-multi-comp */
/* eslint-disable react/display-name */
import HomeIcon from '@material-ui/icons/HomeOutlined';
import Map from 'mdi-material-ui/Map';
import Tractor from 'mdi-material-ui/Tractor';
import DeviceHub from '@material-ui/icons/DeviceHub';
import { AccountCircle } from 'mdi-material-ui';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import FactCheckOutlinedIcon from '@mui/icons-material/FactCheckOutlined';
import { QuestionMark } from '@mui/icons-material';

export default [
  {
    title: 'Pages',
    pages: [
      {
        title: 'dashboard',
        href: '/',
        icon: HomeIcon,
        dashboard: true,
        weather: false,
      },
      {
        title: 'property_plural',
        href: '/properties',
        icon: Tractor,
      },
      {
        title: 'field_plural',
        href: '/fields',
        icon: Map,
      },
      {
        title: 'device_plural',
        href: '/devices',
        icon: DeviceHub,
      },
      {
        title: 'Plans',
        href: '/plans',
        icon: FactCheckOutlinedIcon,
      },
      {
        title: 'events',
        href: '/events',
        icon: CalendarMonthIcon,
      },
      {
        title: 'Help',
        href: '/help',
        icon: QuestionMark,
      },
      {
        title: 'admin',
        href: '/admin',
        icon: AccountCircle,
      },
    ],
  },
];
